export default function AdminRouteConfig($stateProvider, gettext) {
  'ngInject';

  //admin breadcrumb names, need to declare this way to make sure the labels get put into the pot file.
  let admin = gettext('Users'); // eslint-disable-line no-unused-vars
  let adminEdit = gettext('Edit'); // eslint-disable-line no-unused-vars
  let adminInvite = gettext('Invite a User'); // eslint-disable-line no-unused-vars
  let adminRoles = gettext('Roles'); // eslint-disable-line no-unused-vars
  let adminCreate = gettext('Create'); // eslint-disable-line no-unused-vars
  let adminSecurityGroups = gettext('Security Groups'); // eslint-disable-line no-unused-vars
  let adminManageInvites = gettext('Manage Invites'); // eslint-disable-line no-unused-vars
  gettext('Invite New User');
  gettext('Create New Role');

  $stateProvider
    .state('admin', {
      template: require('./admin.main.html'),
      url: '/admin',
      redirectTo: 'admin.userslist',
      ncyBreadcrumb: {
        label: "{{'Admin' | translate}}",
      },
      requiredFeatures: ['admin'],
    })
    .state('admin.datapointdisplay-list', {
      template: require('./datapoint-display/list/list.html'),
      controller: 'DatapointDisplayListController',
      controllerAs: 'vm',
      url: '/datapointdisplay?packageId&moduleIds',
      reloadOnSearch: false,
      ncyBreadcrumb: {
        label: "{{'Datapoint Displays' | translate}}",
      },
      requiredFeatures: ['admin.datapointdisplay'],
    })
    .state('admin.userslist', {
      url: '/users',
      template: require('./user-management/users/list/list.html'),
      controller: 'UserViewListController',
      ncyBreadcrumb: {
        label: "{{'Users' | translate}}",
      },
      requiredFeatures: ['admin.users'],
    })
    .state('admin.userdetails', {
      url: '/users/{userId}?success',
      template: require('./user-management/users/view/view.html'),
      controller: 'UserViewDetailsController',
      ncyBreadcrumb: {
        parent: 'admin.userslist',
        label: '{{user ? (user.name || "N/A") : ""}}',
      },
      requiredFeatures: ['admin.users'],
    })
    .state('admin.userdetailsedit', {
      url: '/users/{userId}/edit',
      template: require('./user-management/users/view/edit/edit.html'),
      controller: 'UserViewDetailsEditController',
      ncyBreadcrumb: {
        parent: 'admin.userdetails',
        label: "{{'Edit' | translate}}",
      },
      requiredFeatures: ['admin.users.edit'],
    })
    .state('admin.inviteuser', {
      url: '/inviteUser',
      template: require('./user-management/invite-user/invite.html'),
      controller: 'InviteUserController',
      ncyBreadcrumb: {
        parent: 'admin.userslist',
        label: "{{'Invite New User' | translate}}",
      },
      requiredFeatures: ['admin.invite'],
    })
    .state('admin.usersRoleslist', {
      url: '/roles',
      template: require('./role-management/list/list.html'),
      controller: 'RolesListController',
      params: {
        create: false,
        deleted: false,
      },
      ncyBreadcrumb: {
        label: "{{'Roles' | translate}}",
      },
      requiredFeatures: ['admin.roles'],
    })
    .state('admin.createUserRole', {
      url: '/createRole',
      template: require('./role-management/create-role/create.html'),
      controller: 'RoleCreateController',
      ncyBreadcrumb: {
        parent: 'admin.usersRoleslist',
        label: "{{'Create New Role' | translate}}",
      },
      requiredFeatures: ['admin.roles', 'admin.roles.manage'],
    })
    .state('admin.userroledetails', {
      url: '/usersRoles/{roleId}',
      template: require('./role-management/view/view.html'),
      controller: 'RoleViewController',
      ncyBreadcrumb: {
        parent: 'admin.usersRoleslist',
        label: '{{roleData.name}}',
      },
      redirectTo: 'admin.userroledetails.permissions',
      requiredFeatures: ['admin.roles'],
    })
    .state('admin.userroledetails.permissions', {
      url: '/permissions',
      helpState: 'admin.userroledetails',
      template: require('./role-management/view/details/details.permissions.html'),
      ncyBreadcrumb: {
        skip: true,
      },
    })
    .state('admin.userroledetails.datapoints', {
      url: '/datapoints',
      helpState: 'admin.userroledetails',
      template: require('./role-management/view/details/details.datapoints.html'),
      ncyBreadcrumb: {
        skip: true,
      },
    })
    .state('admin.userroledetails.users', {
      url: '/users',
      helpState: 'admin.userroledetails',
      template: require('./role-management/view/details/details.users.html'),
      controller: 'RoleViewDetailsController',
      ncyBreadcrumb: {
        skip: true,
      },
    })
    .state('admin.userroleedit', {
      url: '/usersRoles/{roleId}/edit',
      helpState: 'admin.userroledetails',
      template: require('./role-management/view/edit/edit.html'),
      controller: 'RoleViewEditController',
      ncyBreadcrumb: {
        parent: 'admin.userroledetails',
        label: "{{'Edit' | translate}}",
      },
      requiredFeatures: ['admin.roles', 'admin.roles.manage'],
    })
    .state('admin.securitygroups', {
      url: '/securitygroups',
      template: require('./security-groups/list/list.html'),
      controller: 'SecurityGroupsListController',
      params: {
        create: false,
        deleted: false,
        selfRemoved: false,
      },
      ncyBreadcrumb: {
        label: "{{'Security' | translate}}",
      },
      requiredFeatures: ['admin.securitygroups'],
    })
    .state('admin.securitygroupbase', {
      url: '/securitygroups/{securityGroupId}',
      template: require('./security-groups/view/view.html'),
      controller: 'SecurityGroupsViewController',
      redirectTo: 'admin.securitygroupbase.equipment',
      ncyBreadcrumb: {
        parent: 'admin.securitygroups',
        label: '{{group.name}}',
      },
      requiredFeatures: ['admin.securitygroups'],
    })
    .state('admin.securitygroupbase.equipment', {
      url: '/equipments',
      helpState: 'admin.securitygroupbase',
      template: require('./security-groups/view/assets/assets.html'),
      controller: 'SecurityGroupsViewAssetsController',
      ncyBreadcrumb: {
        skip: true,
      },
    })
    .state('admin.createSecurityGroup', {
      url: '/createSecurityGroup',
      template: require('./security-groups/create-group/create.html'),
      controller: 'SecurityGroupCreateController',
      ncyBreadcrumb: {
        parent: 'admin.securitygroups',
        label: "{{'Create Security Group' | translate}}",
      },
      requiredFeatures: ['admin.securitygroups', 'admin.securitygroups.manage'],
    })
    .state('admin.securitygroupbase.users', {
      url: '/users',
      helpState: 'admin.securitygroupbase',
      template: require('./security-groups/view/users/users.html'),
      controller: 'SecurityGroupsViewUsersController',
      ncyBreadcrumb: {
        skip: true,
      },
    })
    .state('admin.manageinvites', {
      url: '/manageinvites',
      template: `<manage-invites></manage-invites>`,
      ncyBreadcrumb: {
        parent: 'admin.userslist',
        label: "{{'Manage Invites' | translate}}",
      },
      requiredFeatures: ['admin.invite'],
    })
    .state('admin.userinvitehistory', {
      url: '/manageinvites/{userEmail}',
      template: require('./user-management/manage-invites/view/view.html'),
      controller: 'ManageInvitesViewController',
      ncyBreadcrumb: {
        parent: 'admin.manageinvites',
        label: '{{email}}',
      },
      requiredFeatures: ['admin.invite'],
    })
    .state('admin.products', {
      url: '/templates',
      redirectTo: 'admin.products-list',
      helpModuleId: 'assets',
      helpState: 'assets.templates',
      requiredFeatures: ['assets.templates'],
      ncyBreadcrumb: {
        label: "{{'Templates' | translate}}",
      },
    })
    .state('admin.products-list', {
      url: '/templates-list',
      template: require('./assets/products/equipment.products.html'),
      controller: 'ProductsController',
      helpModuleId: 'assets',
      helpState: 'assets.templates',
      requiredFeatures: ['assets.templates'],
      ncyBreadcrumb: {
        label: "{{'Templates' | translate}}",
      },
    })
    .state('admin.products-edit', {
      url: '/templates-list/{id}',
      template: require('./assets/products/equipment.product.details.html'),
      controller: 'ProductDetailController',
      ncyBreadcrumb: {
        label: '{{product.name}}',
        parent: 'admin.products-list',
      },
      helpModuleId: 'assets',
      helpState: 'assets.templates',
      requiredFeatures: ['assets.templates'],
    })
    .state('admin.products-create', {
      url: '/templates-create',
      template: require('./assets/products/equipment.create.html'),
      controller: 'ProductCreateController',
      helpModuleId: 'assets',
      helpState: 'assets.templates',
      requiredFeatures: ['assets.templates', 'assets.templates.manage'],
      ncyBreadcrumb: {
        parent: 'admin.products-list',
        label: "{{'Create New Template' | translate}}",
      },
    })
    .state('admin.manage', {
      url: '/manage',
      template: require('./assets/sharing/manage/manage.shared.assets.html'),
      controller: 'ManageSharedAssetsController',
      controllerAs: 'vm',
      ncyBreadcrumb: {
        label: "{{'Manage Shared Assets' | translate}}",
      },
      requiredFeatures: ['assets.share'],
    })
    .state('admin.share', {
      url: '/share',
      template: require('./assets/sharing/share/share.assets.html'),
      controller: 'ShareAssetsController',
      controllerAs: 'vm',
      ncyBreadcrumb: {
        parent: 'admin.manage',
        label: "{{'Share Assets' | translate}}",
      },
      requiredFeatures: ['assets.share'],
    })
    .state('admin.tag-list', {
      url: '/attributes',
      helpModuleId: 'assets',
      helpState: 'attributes',
      template: `<tag-list></tag-list>`,
      ncyBreadcrumb: {
        label: "{{'Attributes' | translate}}",
      },
      requiredFeatures: ['attributes'],
    })
    .state('admin.tag-details', {
      url: '/attributes/{id}',
      template: '<tag-details></tag-details>',
      helpModuleId: 'assets',
      helpState: 'attributes',
      ncyBreadcrumb: {
        parent: 'admin.tag-list',
        label: '{{vm.tag.key}}',
      },
      requiredFeatures: ['attributes'],
    })
    .state('admin.tag-edit', {
      url: '/attribute/{id}/edit',
      template: '<create-tag></create-tag>',
      helpModuleId: 'assets',
      helpState: 'attributes',
      ncyBreadcrumb: {
        label: '{{vm.tag.key}}',
      },
      requiredFeatures: ['attributes', 'attributes.manage'],
    })
    .state('admin.tag-create', {
      url: '/createAttribute/{id}',
      template: '<create-tag></create-tag>',
      helpModuleId: 'assets',
      helpState: 'attributes',
      ncyBreadcrumb: {
        parent: 'admin.tag-list',
        label: "{{'Create Attribute' | translate}}",
      },
      requiredFeatures: ['attributes', 'attributes.manage'],
    })
    .state('admin.tag-bulk', {
      url: '/bulkAttributes',
      template: '<tag-bulk-apply></tag-bulk-apply>',
      helpModuleId: 'assets',
      helpState: 'attributes',
      ncyBreadcrumb: {
        parent: 'admin.tag-list',
        label: "{{'Bulk Apply Attributes' | translate}}",
      },
      requiredFeatures: ['attributes', 'assets.edit.bulk'],
    })
    .state('admin.subaccounts', {
      url: '/subAccounts',
      template: '<accounts-list></accounts-list>',
      ncyBreadcrumb: {
        parent: 'admin',
        label: "{{'Manage Sub Accounts' | translate}}",
      },
      requiredFeatures: ['admin.subaccounts'],
    });
}
